import { render, staticRenderFns } from "./FixedWebpartContainer.vue?vue&type=template&id=4f087c3d"
import script from "./FixedWebpartContainer.ts?vue&type=script&lang=ts&external"
export * from "./FixedWebpartContainer.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports